import ExternalScripts from 'components/ExternalScripts';
import React from 'react';
import RegistrationScreen from 'screens/RegistrationScreen/template.web';
import DaktelaCustomerChat from 'sections/DaktelaCustomerChat';
import { SMARTFORM } from 'utils/externalScripts';

function Page(): React.JSX.Element {
	return (
		<>
			<ExternalScripts secured includedScripts={[SMARTFORM]} />
			<DaktelaCustomerChat pageType="self-care" />

			<RegistrationScreen />
		</>
	);
}

export default Page;
